<template>
  <!-- -->
  <div class="license-order-detail">
    <list-card class="customer-item" :show-title="false" type="form">
      <data-column label="商户名称" :show-border="false">{{dataDetail.merchantName}}</data-column>
      <data-column label="订单id" :show-border="false">{{dataDetail.qywxOrderId}}</data-column>
      <data-column label="账号类型" :show-border="false">{{accountType(dataDetail)}}</data-column>
      <data-column label="账号数量" :show-border="false">{{dataDetail.accountNumber}}</data-column>
      <data-column label="账号时长" :show-border="false">{{dataDetail.accountDuration}}个月</data-column>
      <data-column label="订单状态" :show-border="false">
        <div v-if="dataDetail.orderStatus === 0">待支付</div>
        <div v-if="dataDetail.orderStatus === 1">已支付</div>
      </data-column>
    </list-card>
    <div class="account-list">
      <list-card class="customer-item" v-for="item in dataDetail.qywxOrderAccounts" :key="item.id" :show-title="false" type="form">
        <data-column label="激活码" :show-border="false">{{item.activeCode}}</data-column>
        <data-column label="账号类型" :show-border="false">{{accountType(item)}}</data-column>
        <data-column label="激活时间" :show-border="false">{{item.activeTime}}</data-column>
        <data-column label="到期时间" :show-border="false">{{item.expireTime}}</data-column>
        <data-column label="绑定账号" :show-border="false">{{item.qywxOpenId}}</data-column>
        <data-column label="职员名称" :show-border="false">
          <ww-open-data v-if="item.qywxOpenId" type="userName" :openid="item.qywxOpenId" />
          <table-button v-else @click="toActive(item)">激活</table-button>
        </data-column>
      </list-card>
    </div>
  </div>
</template>

<script>

import {useRoute, useRouter} from "vue-router";
import ListCard from "@/components/qywx/layout/ListCard.vue";
import DataColumn from "@/components/qywx/data/DataColumn.vue";
import qywxOrderApi from "@/api/normal/sys/qywxOrderApi";
import qywxUtil from "@/util/qywxUtil";
import TableButton from "@/components/h5/button/TableButton.vue";
import * as ww from "@wecom/jssdk";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EC",
  components: {
    TableButton,
    ListCard, DataColumn
  },
  data() {
    return {
      dataDetail: {},
      currentData: {},
    };
  },
  created() {
    qywxUtil.ready().then(() => {
      qywxUtil.initOpenData().then((res) => {
        console.log("注册通讯录组件成功", res)
        this.findById(this.route.query.id);
      });
    });
  },
  methods: {
    findById(id) {
      qywxOrderApi.findById(id).then(data => {
        this.dataDetail = data;
        // 渲染完成后，显示用户名
        this.$nextTick().then(() => {
          qywxUtil.bindQywxName();
        })
      });
    },
    accountType(data) {
      return data.accountType === 1 ? "基础账号" : "互通账号"
    },
    toActive(data) {
      this.currentData = {...data};
      qywxUtil.ready().then(() => {
        // 打开通讯录
        ww.selectEnterpriseContact({
          fromDepartmentId: -1,
          mode: 'single',
          type: [ 'user'],
          success: (res) => {
            // 选择异常
            if (res.errCode !== 0) {
              this.$message.error(res.errMsg)
              return;
            }
            if (res.result.userList.length === 0) {
              this.$message.error("选择的用户无效，请重新选择");
              return;
            }
            let id = res.result.userList[0].id;
            let param = {employeeId: id, code: data.activeCode}
            qywxOrderApi.activeAccount(param).then(res => {
              this.$message.success("激活成功");
              this.findById(this.route.query.id);
              console.log(res)
            });
          },
          fail: (res) => {
            console.log(res)
          },
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.license-order-detail{
  height: 100%;
  overflow: auto !important;
  .account-list{
    padding: 20px;
  }
}
</style>